import React, { useMemo, useState, useRef } from 'react';
import { Reactions } from '@bizzabo/seismo-ui';
import ToggleReactionsButton from './ToggleReactionsButton';
import { useBootstrapSeismoUI } from '../useBootstrapSeismoUI';

const styles = {
    reactionsContainer: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        pointerEvents: 'none',
    },
    reactionsMouseArea: {
        position: 'absolute',
        bottom: 0,
        height: 48,
        left: '50%',
        transform: 'translateX(-50%)',
    },
};

const ReactionsOverlay = (props) => {
    const { activity } = props;

    const { shouldStartSeismo } = useBootstrapSeismoUI(activity);

    const emojiArray = useMemo(() => {
        try {
            return JSON.parse(activity.reactions?.emojis);
        } catch (e) {
            return [];
        }
    }, []);

    const emojiCount = emojiArray.length;

    const [reactionsRef, setReactionsRef] = useState({});
    const [visible, setVisible] = useState(false);

    const reactionsContainerWidth = visible ? EMOJI_SIZE * emojiCount + REACTIONS_PADDING : 0;
    const reactionsMouseAreaRef = useRef(null);

    if (!shouldStartSeismo) {
        return null;
    }

    return (
        <>
            <div
                className='reactions-mouse-area'
                style={{ ...styles.reactionsMouseArea, width: reactionsContainerWidth }}
                ref={reactionsMouseAreaRef}
            />
            <Reactions
                ref={setReactionsRef}
                className='reactions-container'
                style={styles.reactionsContainer}
                emojis={activity.reactions?.emojis}
                onPanelVisibilityChange={setVisible}
                config={{
                    panel: {
                        mode: 'manual'
                    }
                }}
                reactionsMouseAreaRef={reactionsMouseAreaRef}
            />
            <ToggleReactionsButton
                visible={visible}
                onClick={reactionsRef?.toggleVisibility}
            />
        </>
    );
};

const EMOJI_SIZE = 36;
const REACTIONS_PADDING = 20;

export default ReactionsOverlay;
